import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConstants } from 'src/app/commons/app-constants';

const KEY = 'crm_sales_ref';

/**
 * Captures the `?ref=<salesperson code>` a visitor arrives with and, once they're logged in,
 * hands it to the backend to tag their company (backend only sets it if empty + CRM enabled).
 * Deliberately tiny and best-effort — a failure here must never affect anything else.
 */
@Injectable({ providedIn: 'root' })
export class SalesRefService {

  constructor(private http: HttpClient) {}

  /** Call once on app start. */
  capture(): void {
    try {
      const ref = new URLSearchParams(window.location.search).get('ref');
      if (ref && ref.length <= 30 && !localStorage.getItem(KEY)) {
        localStorage.setItem(KEY, ref.trim());
      }
    } catch { /* private mode / blocked storage — ignore */ }
  }

  /** Call after the app knows the user is logged in. No-ops if nothing pending. */
  flush(): void {
    let ref: string | null = null;
    try { ref = localStorage.getItem(KEY); } catch { return; }
    if (!ref) return;
    const params = new HttpParams().set('code', ref);
    this.http.post(`${AppConstants.API_URL}api/v1/crm/company-ref`, null, { params, withCredentials: true })
      .subscribe({
        next: () => { try { localStorage.removeItem(KEY); } catch { /* ignore */ } },
        error: () => { /* not logged in yet / CRM off — try again next app load */ },
      });
  }
}
